import { useEffect, useState } from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';

export interface ChartColors {
  series: string;
  negative: string;
  grid: string;
  axisText: string;
  surface: string;
  text: string;
}

const readColors = (): ChartColors => {
  const style = getComputedStyle(document.documentElement);
  const v = (name: string, fallback: string) => style.getPropertyValue(name).trim() || fallback;
  return {
    series: v('--color-accent-border', '#2196f3'),
    negative: v('--color-error-text', '#c62828'),
    grid: v('--color-border-primary', '#e5e7eb'),
    axisText: v('--color-text-secondary', '#666666'),
    surface: v('--color-surface', '#ffffff'),
    text: v('--color-text-primary', '#333333'),
  };
};

/**
 * Recharts tar farger som SVG-attributter, der var(--x) ikke virker. Leser derfor
 * temavariablene (Temasystem-Guide) — ingen hardkodede farger. ThemeProvider setter
 * data-theme i sin egen effekt (etter barnas), så lesingen skjer i neste frame.
 */
export function useChartColors(): ChartColors {
  const { theme } = useTheme();
  const [colors, setColors] = useState<ChartColors>(readColors);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setColors(readColors()));
    return () => cancelAnimationFrame(frame);
  }, [theme]);

  return colors;
}
